import React from 'react';
import { Button, Icon, Message } from 'semantic-ui-react'

/**
 * Panel consent banner shown under the header.
 */
export default class PanelConsent extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			justConfirmed: false
		};
	}

	componentDidMount() {
		// Fetch panel consent status from API
		this.props.fetchPanelConsent();
	}

	componentDidUpdate(prevProps) {
		// When cycleName is loaded and we have visitorId, check if user already consented
		if (
			this.props.cycleName !== undefined &&
			this.props.cycleName !== "" &&
			prevProps.cycleName !== this.props.cycleName &&
			this.props.visitorId !== undefined
		) {
			this.props.checkConsentStatus(this.props.cycleName, this.props.visitorId);
		}
	}

	handleConfirm = () => {
		// Save panel consent via API
		this.props.savePanelConsent(
			this.props.visitorName,
			this.props.visitorId,
			this.props.cycleName
		);
		this.setState({ justConfirmed: true });
	}

	render() {
		// If cycleName is undefined, don't show the component
		if (this.props.cycleName === undefined || this.props.cycleName === "") {
			return null;
		}

		// Show loading state
		if (this.props.isLoading) {
			return null;
		}

		if (this.props.hasConsented) {
			return (
				<Message positive icon>
					<Icon name='check circle' />
					<Message.Content>
						<Message.Header>Panelmódosítások</Message.Header>
						{this.state.justConfirmed
							? 'Köszönjük! A nyilatkozatot rögzítettük erre a ciklusra.'
							: 'A jelen ciklusra vonatkozó panelmódosítások már véglegesítve vannak.'}
					</Message.Content>
				</Message>
			);
		}

		return (
			<Message warning icon>
				<Icon name='clipboard check' />
				<Message.Content>
					<Message.Header>Panelmódosítások véglegesítése</Message.Header>
					Kérjük, erősítsd meg, hogy a panelmódosításokat befejezted, átnézted,
					és a jelen ciklusra <b>({this.props.cycleName})</b> véglegesnek szánod.
				<div style={{ marginTop: '10px' }}>
					<Button 
						primary 
						onClick={this.handleConfirm}
						loading={this.props.isSaving}
						disabled={this.props.isSaving}
					>
						<Icon name='check' />
						Nyilatkozom, lezártam
					</Button>
				</div>
				</Message.Content>
			</Message>
		);
	}
}
